import { useEffect } from 'react';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';

export const useKeyboardScroll = () => {
    useEffect(() => {
        if (!Capacitor.isNativePlatform()) {
            return;
        }

        let keyboardDidShowListener: PluginListenerHandle | null = null;
        let keyboardWillHideListener: PluginListenerHandle | null = null;
        let originalPaddingBottom = '';

        const setupKeyboardListener = async () => {
            keyboardDidShowListener = await Keyboard.addListener('keyboardDidShow', (info) => {
                const activeElement = document.activeElement as HTMLElement;
                const keyboardHeight = info.keyboardHeight;

                originalPaddingBottom = document.body.style.paddingBottom;
                document.body.style.paddingBottom = `${keyboardHeight}px`;

                if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA')) {
                    setTimeout(() => {
                        activeElement.scrollIntoView({
                            behavior: 'smooth',
                            block: 'center'
                        });
                    }, 200);
                }
            });

            keyboardWillHideListener = await Keyboard.addListener('keyboardWillHide', () => {
                document.body.style.paddingBottom = originalPaddingBottom;
            });
        };

        setupKeyboardListener();

        return () => {
            if (keyboardDidShowListener) {
                keyboardDidShowListener.remove();
            }
            if (keyboardWillHideListener) {
                keyboardWillHideListener.remove();
            }
            document.body.style.paddingBottom = originalPaddingBottom;
        };
    }, []);
};
